import { fetchSenderIds, requestSenderId } from "@/api/senderIdService";

export default {
  //Request senderId
  async requestSenderId({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.senderIdRequestBtn.load = true;
      rootState.loading.senderIdRequestBtn.disabled = true;
      await requestSenderId(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Request sent!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.senderIdRequestBtn.load = false;
      rootState.loading.senderIdRequestBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.senderIdRequestBtn.load = false;
      rootState.loading.senderIdRequestBtn.disabled = false;
    }
  },

  //Fetch sent
  async fetchSenderIds({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchSenderIds(pageNumber);
      const senderIds = response.data.data;
      commit("SET_SENDERID_DATA", senderIds);
      commit("SET_SENDERID_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your senderIds arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },
};
